import React, { useState, useCallback, useEffect } from 'react';
import { useQuery } from '@apollo/react-hooks';
import Lottie from 'react-lottie';
import { path, pathOr } from 'ramda';
import { Layout, Button, Link, AppProvider, Stack } from '@shopify/polaris';
import { GET_CURRENT_SUBSCRIPTION } from '../apollo/queries';
import '@shopify/polaris/dist/styles.css';
import { default as animationData } from '../../assets/animations/success.json';

const SucessScreen = (props) => {
  const node = document.getElementsByClassName('shop_container');
  const data = JSON.parse(node[0].getAttribute('data-react-props'));
  const { shopifyToken } = { ...props };
  const changeRoute = path(['history', 'push'])(props);

  const { data: subscriptionData } = useQuery(GET_CURRENT_SUBSCRIPTION, { variables: { shopifyToken } });
  const subscriptionType = pathOr('', ['shop', 'currentSubscription', 'subscriptionType'])(subscriptionData);
  return (
    <AppProvider>
      <Layout>
        <div className='Subscription-Success_content'>
          <Stack alignment={'center'} spacing={'extraLoose'}>
            <div class='Polaris-EmptyState__DetailsContainer'>
              <div class='Polaris-EmptyState__Details'>
                <div class='Polaris-TextContainer'>
                  <p class='Polaris-DisplayText Polaris-DisplayText--sizeMedium'>Nice work!</p>
                  <div class='Polaris-EmptyState__Content'>
                    <p>Get started with ShopHire {subscriptionType}</p>
                  </div>
                </div>
                <div class='Polaris-EmptyState__Actions'>
                  <div class='Polaris-Stack Polaris-Stack--alignmentCenter'>
                    <div class='Polaris-Stack__Item'>
                      <Button primary onClick={() => changeRoute('/set-job')}>
                        Post Job
                      </Button>
                    </div>
                    <div class='Polaris-Stack__Item'>
                      <Link onClick={() => changeRoute('/job-list')} removeUnderline>
                        Check your jobs
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class='Polaris-EmptyState Polaris-EmptyState--withinPage'>
              <div class='Polaris-EmptyState__Section'>
                <div class='Polaris-EmptyState__ImageContainer'>
                  <Lottie
                    options={{
                      loop: true,
                      autoplay: true,
                      animationData: animationData,
                      rendererSettings: {
                        preserveAspectRatio: 'xMidYMid slice',
                      },
                    }}
                    height={400}
                    width={400}
                    isStopped={false}
                    isPaused={false}
                  />
                </div>
              </div>
            </div>
          </Stack>
        </div>
      </Layout>
    </AppProvider>
  );
};

export default SucessScreen;
